var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`
		page-${this.$route.name}
		animate-${this.$route.name === 'PageHome' ? 'forward' : 'reverse'}
		${_vm.loaded ? 'state-has-loaded' : ''}
	`,attrs:{"id":"app"}},[_c('ViewNavigationBar'),(_vm.loaded)?_c('transition',{attrs:{"name":"none"}},[_c('router-view')],1):_vm._e(),_c('ViewPreloader'),_c('ViewFooter'),_c('ViewDialogCookie')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }